import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { UserType } from '../validation';

/**
 * @example <RequireScope scopes={['entity:op']}>something</RequireScope>
 */
class RequireScope extends Component {
  render() {
    const {
      user,
      children,
      forbidden,
      scopes
    } = this.props;

    const allowed = scopes.every((role) => user.scopes.includes(role));

    return allowed ? children : forbidden;
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

RequireScope.propTypes = {
  scopes: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node,
  forbidden: PropTypes.node,
  user: UserType.isRequired,
};

RequireScope.defaultProps = {
  children: null,
  forbidden: null,
};

export default connect(mapStateToProps)(RequireScope);
